import cx from 'classnames';
import { TTypographyTextSize, TypographyTextProps } from './types';
import { getCommonClassName } from './utils';
import { ElementType } from 'react';

const SIZE_CLASS_NAME_MAP: Record<TTypographyTextSize, string> = {
  large: 'slds-text-body--large',
  medium: 'slds-text-body--regular',
  small: 'slds-text-body--small',
  inherit: ''
};

export const Text = <T extends ElementType = 'div'>({
  children,
  size = 'medium',
  component,
  className,
  strong,
  shadow,
  italic,
  color,
  align,
  textWrap,
  transform,
  ellipsis,
  underlineOnHover,
  ...props
}: TypographyTextProps<T>) => {
  const Component = component || 'span';
  return (
    <Component
      className={cx(
        SIZE_CLASS_NAME_MAP[size],
        getCommonClassName({
          strong,
          shadow,
          italic,
          color,
          className,
          align,
          textWrap,
          transform,
          ellipsis,
          underlineOnHover
        })
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
